import Utils from '../../modules/utils'

const updateProperty = (property, callbackFunc) => {
  const url = 'properties/' + property['id']
  Utils.put(url, {property}, callbackFunc)
}

export {updateProperty}
